"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const react_i18next_1 = require("react-i18next");
const svgs_1 = require("@@/assets/svgs");
const ClickAwayListener_1 = __importDefault(require("@mui/material/ClickAwayListener"));
const Tooltip_1 = __importDefault(require("@mui/material/Tooltip"));
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
function default_1() {
    const [open, setOpen] = (0, react_1.useState)(false);
    const handleClose = () => setOpen(false);
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsx)(ClickAwayListener_1.default, Object.assign({ onClickAway: handleClose }, { children: (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(Tooltip_1.default, Object.assign({ open: open, placement: "bottom", title: (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "body2", css: { color: 'var(--white)' } }, { children: t('정산 시 운송장 필수') })), arrow: true, disableFocusListener: true, disableHoverListener: true, disableTouchListener: true, componentsProps: {
                    tooltip: {
                        sx: {
                            p: '6px 10px',
                            borderRadius: '8px',
                            mt: '3px !important',
                            bgcolor: 'var(--primary-dark)',
                            '.MuiTooltip-arrow': {
                                color: 'var(--primary-dark)',
                            },
                        },
                    },
                } }, { children: (0, jsx_runtime_1.jsx)(IconButton_1.default, Object.assign({ onClick: e => {
                        e.preventDefault();
                        setOpen(!open);
                    } }, { children: open ? ((0, jsx_runtime_1.jsx)(svgs_1.InfoIconOrangeSvg, { css: { width: '14px', height: '14px', margin: '1px' } })) : ((0, jsx_runtime_1.jsx)(svgs_1.InfoIconBlackSvg, { css: { path: { fillOpacity: 0.3 } } })) })) })) }) })));
}
exports.default = default_1;
